<template>
  <section class="py-3">
    <div class="container text-center">
      <h2 class="mb-3">
        Favorite Asked Questions
      </h2>
      <div class="sections">
        <ul
          v-for="(section, index) in Object.keys(entries)"
          :key="index"
          class="list list-unstyled"
        >
          <router-link
            v-for="entry in entries[section]"
            :key="entry.id"
            tag="li"
            :to="{ name: entry.id }"
          >
            <a class="text-dark font-weight-light">
              {{ entry.title }}
            </a>
          </router-link>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
import BLOGENTRIES from '@/statics/data/blogs.json'

export default {
  computed: {
    entries() {
      return BLOGENTRIES
    }
  },
}
</script>
